export enum DefaultColorList {
    PrimaryColor = '#0B8453',
    SecondaryColor = '#106789',
    LightPrimaryColor = '#0b84531f',
    DarkPrimaryColor = '#085E3B',
    ErrorColor = '#CA1008',
    ErrorContainerColor = '#FED9D7',
    OnErrorContainerColor = '#490703',
}
